import React from 'react';
import { i18next } from '@yola/ws-sdk';
import contextMenu from 'src/js/modules/context-menu';
import segment from 'src/js/modules/analytics/segment';
import BlockHideOnContainer from '../containers/block-hide-on-container';
import getRootBlockByElement from '../helpers/get-root-block-by-element';
import { CONTEXT_MENU_VISIBILITY_GROUP_NAME } from '../constants/common';
import { HIDE_BLOCK_ON } from '../constants/context-menu-block-items';

const SMALL_SCREEN_GROUP_ORDER = -1;

// Keep the breakpoint in sync with the context menu styles
// which is located in src/scss/context-menu.scss
const isSmallScreen = () => window.innerWidth < 768;

export const registerBlockVisibilityContextMenu = () => {
  contextMenu.operations.registerItemsGroup({
    groupName: CONTEXT_MENU_VISIBILITY_GROUP_NAME,
    groupOrder: isSmallScreen() ? SMALL_SCREEN_GROUP_ORDER : undefined,
    prepareElement: (element) => getRootBlockByElement(element),
    items: [
      {
        id: HIDE_BLOCK_ON,
        matches: (element, featureFlags = {}) =>
          Boolean(featureFlags.breakpoint_editing) && Boolean(getRootBlockByElement(element)),
        menuNode: (
          <BlockHideOnContainer
            title={i18next.t('Hide block on')}
            triggerId={segment.constants.triggerIds.BLOCK_CONTEXT_MENU}
          />
        ),
      },
    ],
  });
};
